import { StockPublicationSliceState } from "../types";

export const initialState: StockPublicationSliceState = {
  dictionaries: null,
  savedSettings: null,
  draftSettings: null,
  isLoading: false,
  isSaving: false,
  error: null,
};
